import { Button } from "@cmp-src/primitives/button";
import { ColumnInstance } from "react-table";

/** The header of a team week day column: sorts the rows by where people are that day. */
export const SortButton = <T extends object>({
  column: { id, toggleSortBy },
  label
}: {
  column: ColumnInstance<T>;
  /** The accessible name, e.g. "Sort by Tuesday": the visible day letter repeats in a week. */
  label?: string;
}) => {
  const name = id.split("_")[0];
  return (
    <Button
      onClick={() => toggleSortBy()}
      variant="ghost"
      aria-label={label}
      className="w-full font-normal text-secondary-text"
    >
      <span className="text-muted-foreground capitalize">{name}</span>
    </Button>
  );
};
